import React, { useState, useEffect } from "react";
import GeneralService from "services/GeneralService";
import { NewPostContext } from "store/contexts/newPostContext";
import { getGradient } from "utils/helpers";
import CreateStatusPost from "./NewPostTypes/CreateStatusPost";
import CreateBrightIdeaPost from "./NewPostTypes/CreateBrightIdeaPost";
import CreateTeamVideoPost from "./NewPostTypes/CreateTeamVideoPost";
import CreateSlideShowPost from "./NewPostTypes/CreateSlideShowPost";
import CreateCelebrationPost from "./NewPostTypes/CreateCelebrationPost";
import CreateCheckInPost from "./NewPostTypes/CreateCheckInPost";

export default ({ type, setType, joinTheWaterCooler, setShowWaterCooler }) => {
  const [postColors, setPostColors] = useState([]);
  const [newPostTypes] = useState({
    status: CreateStatusPost,
    checkin: CreateCheckInPost,
    celebration: CreateCelebrationPost,
    brightidea: CreateBrightIdeaPost,
    teamvideo: CreateTeamVideoPost,
    slideshow: CreateSlideShowPost,
  });

  useEffect(() => {
    (async () => {
      const response = await GeneralService.getColors();

      setPostColors(
        response.data.data.map((color) => {
          color.gradientString = getGradient(color.color_gradient);
          color.textColor =
            color.name.toLowerCase() === "white" ? "black" : "white";
          return color;
        })
      );
    })();
  }, []);

  const NewPostType = newPostTypes[type] ?? newPostTypes["status"];

  return (
    <NewPostContext.Provider
      value={{
        postColors,
      }}
    >
      <NewPostType
        setType={setType}
        setShowWaterCooler={setShowWaterCooler}
        joinTheWaterCooler={joinTheWaterCooler}
      />
    </NewPostContext.Provider>
  );
};
